/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PastInvoicesDTO
 */
export interface PastInvoicesDTO {
    /**
     * 
     * @type {string}
     * @memberof PastInvoicesDTO
     */
    pastInvoices: string;
}

/**
 * Check if a given object implements the PastInvoicesDTO interface.
 */
export function instanceOfPastInvoicesDTO(value: object): value is PastInvoicesDTO {
    if (!('pastInvoices' in value) || value['pastInvoices'] === undefined) return false;
    return true;
}

export function PastInvoicesDTOFromJSON(json: any): PastInvoicesDTO {
    return PastInvoicesDTOFromJSONTyped(json, false);
}

export function PastInvoicesDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PastInvoicesDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'pastInvoices': json['pastInvoices'],
    };
}

export function PastInvoicesDTOToJSON(value?: PastInvoicesDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'pastInvoices': value['pastInvoices'],
    };
}

